import { render, staticRenderFns } from "./CbsPrograms.vue?vue&type=template&id=43bd4afd&scoped=true"
import script from "./CbsPrograms.vue?vue&type=script&lang=js"
export * from "./CbsPrograms.vue?vue&type=script&lang=js"
import style0 from "./CbsPrograms.vue?vue&type=style&index=0&id=43bd4afd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43bd4afd",
  null
  
)

export default component.exports